/** Sharing with more recipients than this in one submit asks for confirmation first. */
export const BULK_SHARE_CONFIRM_THRESHOLD = 5

/**
 * Splits a recipient field into addresses. Commas are the documented separator; semicolons and
 * whitespace are accepted too because address lists pasted from mail clients use them. Repeats
 * are dropped case-insensitively, keeping the first spelling, since the server matches usernames
 * without regard to case.
 */
export function parseRecipients(input: string): string[] {
  const seen = new Set<string>()
  const recipients: string[] = []
  for (const raw of input.split(/[,;\s]+/)) {
    const address = raw.trim()
    if (!address) continue
    const key = address.toLowerCase()
    if (seen.has(key)) continue
    seen.add(key)
    recipients.push(address)
  }
  return recipients
}
